import { render, staticRenderFns } from "./globalVStickyActions.vue?vue&type=template&id=4fbb4e78&scoped=true"
import script from "./globalVStickyActions.vue?vue&type=script&lang=js"
export * from "./globalVStickyActions.vue?vue&type=script&lang=js"
import style0 from "./globalVStickyActions.vue?vue&type=style&index=0&id=4fbb4e78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbb4e78",
  null
  
)

export default component.exports